export default {
  jsArrayToJsonString(arr) {
    return JSON.stringify(arr);
  },
  jsonObjectToString(jsonObject) {
    return JSON.stringify(jsonObject);
  },
  jsonStringToObject(jsonStr) {
    return JSON.parse(jsonStr);
  },
};
